import { forwardRef, type InputHTMLAttributes, type ReactNode, useId } from "react";

import { cn } from "./lib/cn";

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  /**
   * `ReactNode`, salt `string` DEĞİL — bazı çağıranlarda etiket bir bağlantı içeriyor
   * (mockup: "Kullanım Şartları'nı okudum ve **kabul ediyorum**" gibi zorunlu onaylar).
   * `string` kalsaydı o metni ayrı bir `<label>` ile sarmak gerekirdi ve iki `<label>`
   * iç içe geçersiz HTML/duyuru olurdu.
   */
  label: ReactNode;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, className, id, ...rest },
  ref,
) {
  const autoId = useId();
  const inputId = id ?? autoId;
  return (
    <label
      htmlFor={inputId}
      className={cn("inline-flex items-center gap-2 text-sm text-fg-strong", className)}
    >
      <input ref={ref} id={inputId} type="checkbox" className="size-4 accent-primary" {...rest} />
      {label}
    </label>
  );
});
